import { default as NewQuestion } from './NewQuestion';

export default NewQuestion;
